import { Container, Graphics, Sprite } from 'pixi.js';
import { getAsset, getIcon, onAssetsLoad } from 'game/preloadGameAssets';
import { DesignTabs } from './DesignSection';
import { Store } from 'game/store/gameStore';
import { GameName } from 'constants/difficulty';
import gsap, { Power1 } from 'gsap';

type Tab = { type: DesignTabs; active: boolean };
const BAR_WIDTH = 336;
const BAR_HEIGHT = 34;

export class DesignTopBar {
    public currentTab: number;
    public container: Container;
    selectedTab: Graphics;
    tabs = [] as Tab[];
    onChange: (tab: DesignTabs) => void;
    buttonWidth = 0;
    icons = [] as Container[];
    tabsRendered = false;
    constructor(onChange: (tab: DesignTabs) => void) {
        this.changeTab = this.changeTab.bind(this);
        this.container = new Container();
        this.currentTab = 0;
        this.onChange = onChange;

        this.selectedTab = new Graphics();

        this.setTabs();

        this.selectButton();
    }
    show() {
        this.changeTab(this.tabs[0].type, 0);
    }
    setTabs() {
        switch (Store.name) {
            case GameName.FREECELL:
                this.tabs = [
                    { type: DesignTabs.FRONTS, active: true },
                    { type: DesignTabs.BACKGROUNDS, active: false },
                ];
                break;
            default:
                this.tabs = [
                    { type: DesignTabs.BACKS, active: false },
                    { type: DesignTabs.FRONTS, active: true },
                    { type: DesignTabs.BACKGROUNDS, active: false },
                ];
                break;
        }
        onAssetsLoad(this.drawTopBar.bind(this));

        this.selectedTab.roundRect(
            -this.buttonWidth / 2,
            -BAR_HEIGHT / 2,
            this.buttonWidth,
            BAR_HEIGHT,
            BAR_HEIGHT / 2
        );
        this.selectedTab.fill(0x149246);
    }

    public selectButton() {
        gsap.to(this.selectedTab, {
            x: -BAR_WIDTH / 2 + this.buttonWidth / 2 + this.buttonWidth * this.currentTab,
            duration: 0.1,
            ease: Power1.easeInOut,
        });

        this.icons.forEach((icon, index) => {
            icon.alpha = index === this.currentTab ? 1 : 0.6;
        });
    }

    public drawTopBar() {
        this.buttonWidth = BAR_WIDTH / this.tabs.length;
        this.tabs.forEach((tab, index) => {
            const button = new Graphics();
            button.rect(-this.buttonWidth / 2, -BAR_HEIGHT / 2, this.buttonWidth, BAR_HEIGHT);
            button.fill(0xffffff);
            button.alpha = 0.0000001;
            this.container.addChild(button);

            button.cursor = 'pointer';
            button.eventMode = 'static';

            button.on('pointerdown', () => {
                this.changeTab(tab.type, index);
            });
            button.position.x = -BAR_WIDTH / 2 + this.buttonWidth / 2 + this.buttonWidth * index;
            this.drawIcon(tab.type, button);
        });

        const background = new Graphics();
        const padding = 4;
        background.roundRect(
            -BAR_WIDTH / 2 - padding,
            -BAR_HEIGHT / 2 - padding,
            BAR_WIDTH + padding * 2,
            BAR_HEIGHT + padding * 2,
            BAR_HEIGHT + padding
        );
        background.fill(0xffffff);
        background.alpha = 0.15;
        this.container.addChild(background);
        if (!this.tabsRendered) {
            this.tabsRendered = true;
            this.setTabs();
            this.container.addChild(this.selectedTab);
        }
    }
    async drawIcon(type: DesignTabs, button: Graphics) {
        const sprite = await getIcon(`settings/card-${type}`);

        this.container.addChild(sprite);
        sprite.position.set(button.position.x, 0);
        this.icons.push(sprite);
    }
    changeTab(type: DesignTabs, index: number) {
        this.currentTab = index;

        this.selectButton();
        this.onChange(type);
    }
}
